import { base64ToHex } from 'util/Utils'

export function persistState(currentScreen, state, props, featureFlags) {
  try {
    if (featureFlags.EnableInboundLog) {
      const userId = base64ToHex(props.userReducer.user._id, { convertToHEXUUID: true }).toLowerCase()

      const inboundState = {
        RequestFlowID: state.requestFlowId,
        CurrentScreen: currentScreen,
        State: state,
        UserID: userId
      }

      props.makeRequest(inboundState, {
        type: 'post',
        endpoint: '/inbound-state/',
      })
    }
  } catch (error) {
    console.log(error)
  }
}